// app/javascript/projects/components/CodebookCodePageContainer.jsx

import React from 'react';
import { useHistory } from 'react-router-dom';
import { useCodeDetails } from 'hooks/codes/queries';
import CodePageContainer from './CodePageContainer';

function CodebookCodePageContainer({ codeID, projectID, hasEditPermission }) {
  const history = useHistory();
  const { data: code, isLoading: codeLoading } = useCodeDetails(codeID);
  
  const hideModal = () => {
    history.push(`/projects/${projectID}/codes`);
  };

  const show = !codeLoading && !!code;
  
  return (
    <CodePageContainer
      codeID={codeID}
      projectID={projectID}
      hasEditPermission={hasEditPermission}
      show={show}
      hideModal={hideModal}
      codePage={true}
    />
  );
}

export default CodebookCodePageContainer;
